import React, { Component } from 'react';
import SamplePacks from 'decentralized/SamplePacks';
import { Badge } from 'reactstrap';

import '../SamplePacks.css';

const samplePacks = new SamplePacks();

class SamplePacksListComponent extends Component {
    constructor(props) {
        super(props);
        this.state ={
            samplePacks: []
        };
        this.getSamplePacks();
    }

    async getSamplePacks() {
        let s = await samplePacks.getAllSamplePacks();
        this.setState({samplePacks: s});

    }

    onClickDelete(samplePack) {
        if (window.confirm("Are you sure you want to delete this sample pack?")) {
            samplePack.isArchived = true;
            samplePacks.updateSamplePack(samplePack.id, samplePack);
        }
    }

    render() {
        console.log('rendering the damn sample packs');
        console.log(this.state.samplePacks);
        return (
            <div className="sample-packs-list">
              {this.state.samplePacks.map(
                  samplePack =>
                      <SamplePackItem
                        showDeleteButton={this.props.showDeleteButton}
                        onClick={() => this.props.onClickSamplePack(samplePack)}
                        onClickDelete={() => this.onClickDelete(samplePack)}
                        samplePack={samplePack}/>)}
              
            </div>
        );
    }
}

class SamplePackItem extends Component {
    render() {
        return (
            <div className="sample-pack-item" onClick={() => this.props.onClick()}>
              <span className="sample-pack-name">{this.props.samplePack.name}</span>
              {this.props.samplePack.timestamp !== undefined ?
              <span className="sample-pack-date">{this.props.samplePack.timestamp.toLocaleString()}</span> : ''}
              {this.props.samplePack.tags.map(
                tag => <Badge color="light">{tag}</Badge>)}
            {this.props.showDeleteButton ?
             <div className="delete-button" onClick={() => this.props.onClickDelete()} >x</div> : ''}
            </div>
        );
    }
}

export default SamplePacksListComponent;
